/* RESPONSIBLE TEAM: team-messenger */
import Model, { attr } from '@ember-data/model';
export default class MessengerHomeArticleSuggestionModel extends Model {
  @attr('string') id;
  @attr('string') title;
}
